import wcShared from '@web-components/shared';

import bugInformationsStore from '../stores/bugInformations.store';
import formStore from '../stores/form.store';

// import { data as mockBucketsList } from '../mocks/buckets-list.json';

class ReportingToolsReportService {
  body: FormData = new FormData();

  getBuckets(): Promise<Response | void> {
    return wcShared
      .httpCall(
        'GET',
        `/api/components/report?route=${window['CURRENT_ROUTE']}&project=${window['CURRENT_PROJECT']}&service=${window['SERVICE_ID']}`,
      )
      .then((r) => r.json())
      .then((bucketsData) => {
        bucketsData = bucketsData.data;
        const formatedProjectList = Object.keys(bucketsData['list']).map((bucketName) => {
          return {
            bucket_identifier: bucketName,
            ...bucketsData['list'][bucketName],
          };
        });

        formStore.projectsList = formatedProjectList;

        // SET default selected project
        formStore.project =
          formatedProjectList.find(
            (project) =>
              project.title.toLowerCase() === bucketsData['current']?.title.toLowerCase(),
          ) ?? null;

        if (
          !Boolean(formStore.project) &&
          (window['CURRENT_PROJECT'] == 'manager4' || window['CURRENT_PROJECT'] == 'manager3')
        ) {
          formStore.project =
            formatedProjectList.find((project) => project.title.toLowerCase() === 'manager') ??
            null;
        }
        if (!Boolean(formStore.project)) {
          formStore.project =
            formatedProjectList.find((project) => project.title.toLowerCase() === 'bug tracker') ??
            null;
        }
        formStore.typeBug = [];
        if (formStore.project?.actions['bugs']) {
          formStore.typeBug.push({
            label: wcShared?.translate('Bug'),
            value: 'bugs',
          });
        }
        if (formStore.project?.actions['features']) {
          formStore.typeBug.push({
            label: wcShared?.translate('Amelioration'),
            value: 'features',
          });
        }
        if (formStore.typeBug.length >= 1) {
          formStore.type = formStore.typeBug[0].value;
        }
      });
  }

  sendReport(
    bucket_identifier: string,
    subject: string,
    description: string,
    cerberusLink: string,
    reportType: string,
    priorityValue: number,
    priorityLabel: string,
    files: File[],
  ): Promise<{ data: { url: string } }> {
    this.body = new FormData();

    this.body.append('bucket_identifier', bucket_identifier);
    this.body.append('subject', subject);
    this.body.append('description', description);
    if (Boolean(cerberusLink)) this.body.append('cerberusLink', cerberusLink);
    this.body.append('priority[label]', wcShared.translate('Priorite') + ': ' + priorityLabel);
    this.body.append('priority[value]', priorityValue?.toString());
    this.body.append('extra[project]', window['CURRENT_PROJECT'] || null);
    this.body.append('extra[route]', window['CURRENT_ROUTE'] || null);
    this.body.append('extra[userAgent]', window.navigator.userAgent);
    this.body.append('extra[userId]', bugInformationsStore.user?.user_id.toString());
    this.body.append('extra[groupId]', bugInformationsStore.group?.id.toString());
    this.body.append('extra[userMail]', bugInformationsStore.user?.email);
    this.body.append('extra[userDisplayName]', bugInformationsStore.user?.display_name);
    this.body.append('extra[pageLink]', bugInformationsStore.pageUrl);

    this.body.append('type', reportType);

    // Adding files to body
    files.forEach((file, index) => {
      this.body.append('file_' + index, file);
    });

    return wcShared
      .httpCall('POST', '/api/components/report', this.body, false, true)
      .then(this.handleErrors)
      .then((reportResponse) => {
        return reportResponse;
      });
  }

  handleErrors(response: Response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  }
}

export const ReportService = new ReportingToolsReportService();
